import { OrderStatusEnum } from '../enum';
export const RefundableOrderStatuses = Object.freeze([OrderStatusEnum.READY, OrderStatusEnum.NEW, OrderStatusEnum.COMPLETE, OrderStatusEnum.RECEIVED]);
//# sourceMappingURL=RefundableOrderStatuses.js.map